import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c7e33db8"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c7e33db8')) {
      api.createRecord('c7e33db8', component.options)
    } else {
      api.reload('c7e33db8', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c7e33db8", function () {
      api.rerender('c7e33db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/goodsNameTag/index.vue"
export default component.exports